<script>
import KeyboardBoxConnected from './connected/KeyboardBoxConnected.vue';
import StatusBoxConnected from './connected/StatusBoxConnected.vue';
import ControlsBoxGameConnected from './connected/ControlsBoxGameConnected.vue';
import ReviewBoxConnected from './connected/ReviewBoxConnected.vue';
import PauseBoxConnected from './connected/PauseBoxConnected.vue';
import GamesBoxConnected from '@/launcher/components/connected/GamesBoxConnected';
import GamesDetailsBoxConnected from '@/launcher/components/connected/GamesDetailsBoxConnected';
import GamesSearchBoxConnected from '@/launcher/components/connected/GamesSearchBoxConnected';
import FilterBoxConnected from './connected/FilterBoxConnected.vue';
import LanguageSelectBoxConnected from './connected/LanguageSelectBoxConnected.vue';
import ThanksBoxConnected from './connected/ThanksBoxConnected.vue';
import ErrorBoxConnected from './connected/ErrorBoxConnected';
import PanelContainer from '@/launcher/components/shared/PanelContainer.vue';

import LauncherOutlet from '@/launcher/components/routes/VR/outlet/LauncherOutlet.vue';
import Loading from './shared/LoadingRing';

export default {
  name: 'VRApp',
  props: {
    loading: {
      required: true,
    },
    error: {
      required: true,
    },
  },
  data: () => ({
    device: !window.sbvrenv.CEFSHARP ? 'browser' : 'vr',
  }),
  computed: {
    VREnvironment () {
      if (this.$store.state.launcher.appState.runningType === 'launcher') {
        return 'launcher';
      } else if (this.$store.getters.playingGame) {
        return 'game';
      }
      return '';
    },
    notification () {
      return this.$store.state.notifications.launcher.length && this.$store.state.notifications.launcher[0];
    },
  },
  components: {
    KeyboardBoxConnected,
    StatusBoxConnected,
    ControlsBoxGameConnected,
    ReviewBoxConnected,
    ThanksBoxConnected,
    LanguageSelectBoxConnected,
    PauseBoxConnected,
    GamesDetailsBoxConnected,
    GamesBoxConnected,
    GamesSearchBoxConnected,
    FilterBoxConnected,
    PanelContainer,
    LauncherOutlet,
    Loading,
    ErrorBoxConnected,
    DevPanel: () => {
      return window.sbvrenv.NODE_ENV !== 'production'
        ? import('./DevPanel')
        : Promise.resolve({});
    },
  },
  watch: {
    '$route.query.debug': {
      handler (val) {
        if (val) {
          window._VUE_DEBUG = {
            store: this.$store,
            vm: this,
          };
          console.log(window._VUE_DEBUG);
        }
      },
      immediate: true,
    },
  },
};
</script>

<template lang="pug">
div.vr-app(:class="[Boolean($route.query.debug) && '-debug', `-${device}`, `-in-${VREnvironment}`]")
  PanelContainer.devpanel.fixed.top-0.z-max.overflow-hidden(id="dev-panel", :no-title="true")
    DevPanel(v-if="Boolean($route.query.debug)")
  div.container.dib
    PanelContainer.notificationpanel.w-100.h4(id="notificationpanel", :no-title="true", :usage="(notification && notification.usage) || ['launcher', 'dashboard']", :duplicate-panel="true")
      div.msgbox.flex.justify-center.items-center.h-100
        transition(:appear="true", mode="out-in", enter-active-class="animated-500 zoomIn", leave-active-class="animated-500 zoomOut")
          component(:is="notification.component", v-bind="notification.props", v-if="notification", :key="notification.id")
    router-view.h-100(v-if="!loading && !error")
    PanelContainer(v-else-if="loading", key="loading-panel", id="loading-panel", :duplicate-panel="true", style="width:200px", :usage="['launcher', 'dashboard']")
      .bg-black-overlay.pa5._collision
        Loading.center
    PanelContainer(v-else-if="error", key="error-panel", id="error-panel", :duplicate-panel="true", style="width:500px", :usage="['launcher', 'dashboard']")
      ErrorBoxConnected(:error="error")

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="postcss" scoped>
.vr-app {
  & * {
    user-select: none;
  }
  & >>> .panel-container {
    height: 600px;
    flex-shrink: 0;
    /* margin-right: 100px; */
  }
  & .devpanel {
    height: 707px;
    flex-shrink: 0;
    /* margin-right: 100px; */
  }
  & .notificationpanel {
    height: 8rem;
    min-width: 50rem;
  }
  &.-debug {
    &:before {
      content: "";
      position: fixed;
      background-color: gray;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: -1;
    }
    & .container {
      padding-left: 300px;
    }
  }
  &.-debug.-browser.-in-launcher {
    &:before {
      background-image: url("http://data.1freewallpapers.com/download/the-dark-city-1920x1080.jpg");
      background-size: cover;
    }
  }
  &.-debug.-browser.-in-game {
    &:before {
      background-image: url("https://www.vrandfun.com/wp-content/uploads/2016/09/damaged-core-vr-review.png");
      background-size: cover;
    }
  }

  & .container {
    height: 100vh;
  }
}
</style>
<style>
::-webkit-scrollbar {
  display: none;
}
</style>
